export default "__VITE_ASSET__uRlq0A_B__"